import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';

// Support platform Firebase configuration
// This is the supportbookandgo Firebase project (shared with support-platform)
const firebaseConfig = {
  apiKey: 'AIzaSyC8_0z_TdEm9mdmgcSVimDUsppK6CxTr5k',
  authDomain: 'supportbookandgo.firebaseapp.com',
  projectId: 'supportbookandgo',
  storageBucket: 'supportbookandgo.firebasestorage.app',
  messagingSenderId: '597042981577',
  appId: '1:597042981577:web:fe6bda1f6e888c60f93b18',
};

// App name to differentiate from hosting Firebase
const SUPPORT_APP_NAME = 'support-chat';

let app: FirebaseApp;
let db: Firestore;
let storage: FirebaseStorage;

/**
 * Initialize Firebase for Support Hub
 * Uses a named app to avoid conflicts with other Firebase instances
 */
export function initializeSupportFirebase(): { app: FirebaseApp; db: Firestore; storage: FirebaseStorage } {
  if (!app) {
    // Check if this app already exists
    const existingApp = getApps().find((a) => a.name === SUPPORT_APP_NAME);

    if (existingApp) {
      app = existingApp;
    } else {
      app = initializeApp(firebaseConfig, SUPPORT_APP_NAME);
    }

    db = getFirestore(app);
    storage = getStorage(app);

    // Connect to emulator in development (optional)
    if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_FIREBASE_EMULATOR === 'true') {
      connectFirestoreEmulator(db, 'localhost', 8080);
    }
  }

  return { app, db, storage };
}

/**
 * Get Firestore instance for Support Hub
 */
export function getSupportFirestore(): Firestore {
  if (!db) {
    initializeSupportFirebase();
  }
  return db;
}

/**
 * Get Storage instance for Support Hub
 */
export function getSupportStorage(): FirebaseStorage {
  if (!storage) {
    initializeSupportFirebase();
  }
  return storage;
}

/**
 * Get the Firebase app instance
 */
export function getSupportApp(): FirebaseApp {
  if (!app) {
    initializeSupportFirebase();
  }
  return app;
}

// Firestore collection paths
export const COLLECTIONS = {
  clubs: 'clubs',
  messages: (clubId: string) => `clubs/${clubId}/messages`,
  userChatStatus: (clubId: string) => `clubs/${clubId}/userChatStatus`,
  featureRequests: (clubId: string) => `clubs/${clubId}/featureRequests`,
} as const;

// Export singleton instances
export { app, db, storage };
